<template>
  <div class="integration">
    <div class="i-header">
      <slot name="icon" />
      <div v-if="connected" class="i-connected">
        <div class="bullet" />
        <div class="label-info">
          Connected
        </div>
      </div>
      <div
        v-else-if="pending"
        class="i-connected pending"
      >
        <div class="bullet pending" />
        <div class="label-info pending">
          Pending
        </div>
      </div>
    </div>
    <div class="slack-info">
      {{ title }}
    </div>
    <p class="review-info">
      {{ body }}
    </p>
    <div v-if="screen !== 'partnerDetail'">
      <button
        v-if="showConnect"
        type="button"
        class="i-form-button"
        @click="toggleConnect"
      >
        Connect
      </button>
      <button
        v-else
        type="button"
        class="i-form-integration"
        @click="toggleEdit"
      >
        Integration Settings
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationCard',
  props: {
    title: String,
    body: String,
    connected: Boolean,
    pending: Boolean,
    toggleConnect: Function,
    toggleEdit: Function,
    screen: String,
    showConnect: Boolean,
  },
};
</script>
